<template>
  <div></div>
</template>
<script>
export default {
  created () {
    const { queryInfo } = this.$route.query
    this.$router.push({
      path: queryInfo.path,
      query: queryInfo
    })
  }
}
</script>
